import { render, staticRenderFns } from "./ReviewsGrid.vue?vue&type=template&id=1ae97613&scoped=true&name=reviews-grid&"
import script from "./ReviewsGrid.vue?vue&type=script&lang=js&"
export * from "./ReviewsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsGrid.vue?vue&type=style&index=0&id=1ae97613&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae97613",
  null
  
)

export default component.exports